import loadable from '@loadable/component'

export const SVGButton = loadable(() => import('./SVGButton'), {
  resolveComponent: (module) => module.SVGButton
})
export type { SVGButtonProps } from './SVGButton'
